import type { CreateSavedDestinationInput, SavedDestination, UpdateSavedDestinationInput } from "@solomon-apps/shared";

import { orgApiFetch, orgApiFetchVoid } from "./orgApiFetch";

interface SavedDestinationsListResponse {
    data: SavedDestination[];
}

export async function fetchSavedDestinations(): Promise<SavedDestination[]> {
    const result = await orgApiFetch<SavedDestinationsListResponse>("/api/org/client/saved-destinations");
    return result.data;
}

export function createSavedDestination(input: CreateSavedDestinationInput): Promise<SavedDestination> {
    return orgApiFetch<SavedDestination>("/api/org/client/saved-destinations", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(input)
    });
}

export function updateSavedDestination(uuid: string, input: UpdateSavedDestinationInput): Promise<SavedDestination> {
    return orgApiFetch<SavedDestination>(`/api/org/client/saved-destinations/${uuid}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(input)
    });
}

export function deleteSavedDestination(uuid: string): Promise<void> {
    return orgApiFetchVoid(`/api/org/client/saved-destinations/${uuid}`, {
        method: "DELETE"
    });
}
